import { lighten, setLightness } from 'polished';

import { generalTheme } from './dropdowns';
import { COLOR_THEME } from '../utils/themer';
import { WHITE } from './colors';

export const defaultStyle = {
  fontWeight: 'normal',
  fontSize: '14px',
  cursor: 'pointer',
  padding: '12px 30px',
  margin: '2px 0px',
  whiteSpace: 'pre',
  borderLeft: '5px solid transparent',
};

export const selectedStyle = {
  fontWeight: 'bold',
  fontSize: '14px',
  cursor: 'pointer',
  background: setLightness(0.25, COLOR_THEME.primary),
  borderLeft: `5px solid ${COLOR_THEME.secondary}`,
  padding: '12px 30px',
  whiteSpace: 'pre',
  margin: '2px 0px',
};

export const filterItemPickerStyle = {
  ...generalTheme,
  control: styles => ({
    ...styles,
    fontSize: '14px',
    backgroundColor: COLOR_THEME.primary,
    borderColor: lighten(0.25, COLOR_THEME.primary),
    '&:hover': { borderColor: lighten(0.25, COLOR_THEME.primary), cursor: 'pointer' },
    svg: { color: setLightness(0.65, WHITE) },
    boxShadow: 'none',
    borderRadius: 0,
    borderTop: 0,
    borderRight: 0,
    borderLeft: 0,
    width: '100%',
    margin: '0',
  }),
};
